/**
 * MediaUploadList — several files where a form used to take a comma-separated
 * list of URLs. Each row is a MediaUpload; removing a row drops that file.
 */
import React from 'react';
import { Plus } from 'lucide-react';

import { MediaUpload } from '@/components/MediaUpload';

export const MediaUploadList = ({
  value = [],
  onChange,
  purpose = 'photo',
  label,
  hint,
  testId = 'media-upload-list',
}) => {
  const items = Array.isArray(value) ? value : [];
  const set = (i, url) => {
    const next = [...items];
    if (!url) next.splice(i, 1);
    else next[i] = url;
    onChange(next);
  };

  return (
    <div className="space-y-2" data-testid={testId}>
      {label && <span className="block text-xs font-medium text-slate-600">{label}</span>}
      {items.map((url, i) => (
        <MediaUpload key={`${url}-${i}`} value={url} onChange={(u) => set(i, u)}
                     purpose={purpose} testId={`${testId}-${i}`} previewClassName="h-16" />
      ))}
      <MediaUpload value="" onChange={(u) => u && onChange([...items, u])}
                   purpose={purpose} hint={hint || 'Add a file'}
                   testId={`${testId}-add`} />
      {items.length > 0 && (
        <p className="text-[11px] text-slate-400 inline-flex items-center gap-1">
          <Plus className="h-3 w-3" /> {items.length} file{items.length === 1 ? '' : 's'} attached
        </p>
      )}
    </div>
  );
};

export default MediaUploadList;
